import React from "react"
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom"
import { Phone, UserSearch } from "lucide-react"
import Navbar from "./components/Navbar"
import Footer from "./components/Footer"

import Home from "./pages/Home"
import InstituteDetail from "./pages/InstituteDetail"
import Booking from "./pages/Booking"
import DoctorSearch from "./pages/DoctorSearch"

import './App.css'
import About from "./pages/About"
import Institutes from "./pages/Institues"
import ScrollTopButton from './ScrolltoTop';

const App = () => {
  return (
    <Router>
      <div className="min-h-screen flex flex-col font-sans selection:bg-vcnr-brand selection:text-white">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/institute/:id" element={<InstituteDetail />} />
            <Route path="/booking" element={<Booking />} />
            <Route path="/doctors" element={<DoctorSearch />} />
            <Route path="/about" element={<About />} />
            <Route path="/institutes" element={<Institutes />} />
          </Routes>
        </main>
        <Footer />
        <ScrollTopButton/>
   
        {/* Mobile Quick Action Bar - Purple Theme */}
        <div className="fixed bottom-0 left-0 w-full bg-white/95 backdrop-blur-md border-t border-gray-100 md:hidden z-[55] flex justify-around items-center py-4 px-6 shadow-[0_-10px_30px_-15px_rgba(105,65,230,0.3)]">
          <a
            href="tel:+918042451234"
            className="flex flex-col items-center text-gray-400 hover:text-vcnr-brand transition-colors"
          >
            <Phone size={20} />
            <span className="text-[10px] font-black uppercase mt-1 tracking-tighter">
              Emergency
            </span>
          </a>
          <Link
            to="/booking"
            className="bg-vcnr-brand text-white px-8 py-3 rounded-full font-black uppercase text-xs shadow-xl shadow-vcnr-brand/30 transform -translate-y-2"
          >
            Book Now
          </Link>
          <Link
            to="/doctors"
            className="flex flex-col items-center text-gray-400 hover:text-vcnr-brand transition-colors"
          >
            <UserSearch size={20} />
            <span className="text-[10px] font-black uppercase mt-1 tracking-tighter">
              Experts
            </span>
          </Link>
        </div>
      </div>
    </Router>
  )
}

export default App